import { render } from "./StatusWaiting.svg?vue&type=template&id=0dbc74a8"
const script = {}
script.render = render

export default script